import React, { useContext, useEffect, useState } from "react";

import { Formik } from "formik";
import * as Yup from "yup";
import { Container, TextField, CssBaseline } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import AuthContext from "store/AuthContext";
import AppButton from "components/FormsUI/AppButton/appButton";

import PopLogo from "../images/popImmigrationIconOnly.png";
import govSemel from "../images/Emblem_of_Israel.svg";

import "./Login.css";

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    flexDirection: "column",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
  },
}));

function Login(props) {
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const ctx = useContext(AuthContext);
  const classes = useStyles();

  useEffect(() => {
    ctx.signOut();
  }, []);

  const handleSubmit = async (values) => {
    setErrorMessage("");
    setSpinnerLoading(true);
    ctx
      .signIn(values.email)
      .then((usr) => {
        props.history.push({
          pathname: "MFA",
          congnitoUser: usr,
        });
      })
      .catch((err) => {
        setErrorMessage(err.message);
        setSpinnerLoading(false);
    });
};

const emailChangeHandler = (val)=>{
      setErrorMessage('');
  }

  return (
    <Container component="main" maxWidth="xs" className="frame">
      <CssBaseline />
      <div style={{ padding: "48px 40px 20px" }}>
        <div className={classes.header}>
          <div>
            <span className="pull-left" style={{ float: "left" }}>
              <img src={govSemel} height="50" alt="Gov logo" />
            </span>
            <span className="pull-right" style={{ float: "right" }}>
              <img src={PopLogo} height="50" alt="Pop logo" />
            </span>
          </div>
        </div>
        <div className="paper">
          <h1>Sign in</h1>
          <div>
            <h5>to continue to </h5>
          </div>
          <div>
            <h5 style={{ color: "#1976d2" }}>
              Israel iapi portal for airlines
            </h5>
          </div>
          <Formik
            initialValues={{ email: "" }}
            validateOnBlur={false}
            onSubmit={(values, { setSubmitting }) => {
              setSpinnerLoading(true);
              setSubmitting(true);
              handleSubmit(values);
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string()
                .email("Email address is not valid")
                .required("Email address is Required"),
            })}>
            {(props) => {
              const {
                values,
                touched,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
              } = props;
              return (
                <form onSubmit={handleSubmit}>
                  <TextField
                    error={errors.email && touched.email}
                    value={values.email}
                    helperText={errors.email && touched.email && errors.email}
                    variant="outlined"
                    margin="normal"
                    style={{ width: '100%'}}
                    FormHelperTextProps={{classes: { error: "validation-message" } }}
                    id="email"
                    label="Email Address"
                    name="email"
                    autoFocus
                    onChange={(val) => {handleChange(val); emailChangeHandler(val);}}
                    onBlur={handleBlur}
                    type="search"
                  />
                  <div className="mb-1" style={{minHeight: 31}}>
                    {errorMessage && <div className="alert alert-danger p-1">{errorMessage}</div>}
                  </div>
                  <div>
                    <AppButton
                      id="loginSubmitBtn"
                      type="submit"
                      label="Login"
                      isBlock={true}
                      isLoading={spinnerLoading}
                      ></AppButton>
                  </div>
                </form>
              );
            }}
          </Formik>
        </div>
      </div>
    </Container>
  );
}

export default Login;
